module.exports = [
	{
		"imageId": "M35P",
		"imageAlt": "ABI Logo Light",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
		"imageCategory": "logos",
		"imageAdded": "2017-05-02T19:33:00",
		"builtIn": true
	},
	{
		"imageId": "B419I",
		"imageAlt": "ABI Logo Regular",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_pos_large.png",
		"imageCategory": "logos",
		"imageAdded": "2017-05-02T19:33:00",
		"builtIn": true
	},
	{
		"imageId": "G178Z",
		"imageAlt": "Abigail Cartledge",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AbigailCartledge.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "R465Y",
		"imageAlt": "Adeola Ajayi",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/adeolaajayi.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Z11R",
		"imageAlt": "Alastair Ross",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "L778O",
		"imageAlt": "Alisa Dolgova",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlisaDOLGOVA.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "P164P",
		"imageAlt": "Andrew Carpenter",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AndrewCarpenter.JPG",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "J547W",
		"imageAlt": "Anthony Wright",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/anthonywright.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "E679N",
		"imageAlt": "Audrie Powell",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/audriepowell.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "C374P",
		"imageAlt": "Ben Howarth",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/BenHowarth.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "R714J",
		"imageAlt": "Bob Warren",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RobertWarren.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "B605K",
		"imageAlt": "Carol Hall",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/CarolHall.JPG",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "U450G",
		"imageAlt": "Charlie Campbell",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/CharlieCAMPBELL.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "K605T",
		"imageAlt": "Chris Armistead",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/ChrisArmistead.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "I981M",
		"imageAlt": "Christopher Darling",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/ChristopherDarling.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Y936R",
		"imageAlt": "Dan Sadler",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DanSadler.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "J287B",
		"imageAlt": "David Jordonson",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DavidJORDORSON.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "N138A",
		"imageAlt": "Debbie Marsh",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DebbieMarsh.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "O814N",
		"imageAlt": "Denise Brightly",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DeniseBrightly.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "R37P",
		"imageAlt": "Emma Phillips",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/EmmaPHILLIPS.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "I412M",
		"imageAlt": "Glyn Wilkins",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/GlynWilkins.JPG",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "X166X",
		"imageAlt": "Hugh Savill",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HughSAVILL.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "A110R",
		"imageAlt": "Huw Evans",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HuwEvans.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "A130D",
		"imageAlt": "Huw Evans",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/people/abi-staff/current-staff/exec-team/huwevansdgweeklynote.jpg",
		"imageCategory": "people",
		"imageAdded": "2018-06-01T10:06:00",
		"builtIn": true
	},
	{
		"imageId": "A450F",
		"imageAlt": "Jacques Ebosse",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JacquesEbosse.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Z961W",
		"imageAlt": "James Dalton",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/james-dalton-picture.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "F265Z",
		"imageAlt": "Julie Geraud",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JulieGeraud.JPG",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "K406H",
		"imageAlt": "Julie Shah",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/julieshah2.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "R284W",
		"imageAlt": "Kelly Ostler-Coyle",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/KellyOSTLERCOYLE.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-02T19:33:00",
		"builtIn": true
	},
	{
		"imageId": "I275X",
		"imageAlt": "Laura Hughes",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LauraHUGHES.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "K417D",
		"imageAlt": "Liam Findlay",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LiamFindlay.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "F672K",
		"imageAlt": "Lottie Dight",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LottieDight.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "T447W",
		"imageAlt": "Lucy Ashton",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LucyAshton.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "U434Y",
		"imageAlt": "Malcolm Tarling",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MalcolmTarling.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "P257H",
		"imageAlt": "Mark Allen",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MarkAllen.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "O670F",
		"imageAlt": "Mark Shepherd",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MarkShepherd.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "H391O",
		"imageAlt": "Matt Cullen",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MattCULLEN.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "S610U",
		"imageAlt": "Megan Hawkins",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MeganHawkins.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Q757U",
		"imageAlt": "Natalie Larnder",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/NatalieLarnder.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "K267I",
		"imageAlt": "Nicola Abbott",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/nicolaabbott.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "H780W",
		"imageAlt": "Omar Ali",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/OmarALI.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Y356S",
		"imageAlt": "Philippa Handyside",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/PhilippaHandyside.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "M833M",
		"imageAlt": "Raluca Boroianu-Omura",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RalucaBOROIANUOMURA.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "A836B",
		"imageAlt": "Rob Yuille",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RobYuille.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "P544G",
		"imageAlt": "Sarah Cordey",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SarahCORDEY.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "X628L",
		"imageAlt": "Seth Williams",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SethWILLIAMS.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "E484T",
		"imageAlt": "Stef Kenyon",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/stefkenyon2.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "H347G",
		"imageAlt": "Steven Findlay",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StevenFINDLAY.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Y81S",
		"imageAlt": "Taylan Hamit",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/TaylanHamit.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Y764G",
		"imageAlt": "Victoria French",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/VictoriaFRENCH.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	},
	{
		"imageId": "Z612B",
		"imageAlt": "Yvonne Braun",
		"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/YvonneBraun.jpg",
		"imageCategory": "people",
		"imageAdded": "2017-05-03T13:29:00",
		"builtIn": true
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/App/state/images/initialState.json
// module id = 615
// module chunks = 0